/*
  SylverCar — calage horizontal des grands panneaux de menu.

  Ce fichier ne gere PLUS le collage du header.

  Il a longtemps porte un collage maison en position:fixed avec une cale de
  compensation, parce que position:sticky semblait inoperant : le parent du
  header, .t4s-website-wrapper, ne mesurait que 182 px au lieu de toute la
  hauteur de la page.

  La vraie cause etait ailleurs, dans sections/header-inline.liquid : le
  guillemet fermant de l attribut class du .t4s-header__wrapper etait enferme
  dans {% if h__bgimg != blank %}. Aucune image de fond de header n etant
  reglee, il n etait jamais emis, l attribut avalait la balise suivante, un
  <div> disparaissait, et la </div> devenue orpheline refermait le wrapper
  juste apres le header. <main> et <footer> en sortaient.

  Le wrapper repare, position:sticky redevient operant et suffit. La cale, qui
  ajoutait 60 px la ou le header transparent n en occupait aucun (il porte
  margin-bottom: -60px), etait la cause du saut au collage.
*/
/*
  SylverCar — calage horizontal des grands panneaux de menu.

  Le probleme

    Le theme place ces panneaux avec FloatingUI, en les alignant sur le
    CONTENEUR du header puis en les rabattant dans l ecran. Resultat mesure a
    1600 px : le panneau des coussins commencait a 5 px alors que l entree qui
    l ouvre est a 269 px. Le lien ne surplombait donc rien de son panneau.

  Pourquoi ce n est pas une regle CSS

    La position de l entree bouge avec la largeur de la fenetre — 216 px a
    1280, 269 px a 1600, 423 px a 2000. Une valeur figee ne conviendrait qu a
    une seule taille d ecran. Et une regle CSS ne peut pas lire cette position :
    le panneau n est pas positionne par rapport a son entree mais par rapport
    au conteneur du header. Faire de l entree le bloc de reference reglerait
    l axe horizontal mais casserait le vertical, le `top: 100%` du theme se
    mettant alors a compter la hauteur de l entree au lieu de celle du header.

  Ce qu on fait

    Chaque panneau se recale sous l entree qui l ouvre. Les petits panneaux
    s y centrent ; les deux grands, qui portent une image a droite, posent
    l entree au milieu de leurs deux colonnes de texte plutot qu au milieu du
    panneau. Rien n est code en dur : on mesure ce qui est reellement
    affiche, donc le calage suit si le contenu change.

  Pourquoi un observateur

    FloatingUI recrit `left` a chaque ouverture, et une affectation par
    `style.left` efface une priorite `!important` posee avant elle. On surveille
    donc l attribut de style et on repose notre valeur. La comparaison au demi-
    pixel pres empeche l observateur de se reveiller lui-meme en boucle.
*/
(function () {
  // Seuil du theme lui-meme : en dessous, les panneaux deroulants cedent la
  // place au tiroir mobile et il n y a plus rien a caler. Au-dessus, le calage
  // s applique partout — un panneau de 980 px tient dans les 1024 px les plus
  // etroits, la butee de gauche suffit a le garantir.
  var LARGEUR_MINI = 1024;
  var MARGE = 8;
  var MARQUE = 'sylvercarCale';

  function panneaux() {
    var res = [];
    var noeuds = document.querySelectorAll('.t4s-navigation .t4s-type__mega');
    for (var i = 0; i < noeuds.length; i++) {
      var li = noeuds[i];
      var sub = li.querySelector('.t4s-sub-menu');
      if (!sub || sub.parentNode !== li) continue;
      res.push({
        li: li,
        sub: sub,
        listes: sub.querySelectorAll('div.type_mn_link'),
        banniere: !!sub.querySelector('div.type_mn_banner')
      });
    }
    return res;
  }

  function centre(el) {
    var r = el.getBoundingClientRect();
    return { c: r.left + r.width / 2, l: r.left, w: r.width };
  }

  // Le point du panneau qui doit se retrouver sous l entree de menu.
  // Renvoie null si le panneau n est pas encore mesurable.
  function ancrage(p, panneau) {
    // Les deux grands panneaux — coussins et housses — ont trois listes et
    // une image. Pour eux, l entree se pose au milieu des DEUX colonnes de
    // texte, pas au milieu du panneau : l image, a droite, tirerait sinon
    // tout le bloc vers la gauche.
    if (p.listes.length >= 3 && p.banniere) {
      var a = centre(p.listes[0]);
      var b = centre(p.listes[1]);
      if (a.w < 10 || b.w < 10) return null;
      return (a.c + b.c) / 2 - panneau.l;
    }
    // Les autres se centrent simplement sous leur entree.
    return panneau.w / 2;
  }

  // Renvoie false tant que le panneau n est pas mesurable : l appelant
  // reessaiera a la trame suivante.
  function caler(p) {
    var panneau = centre(p.sub);
    if (panneau.w < 10) return false;

    var point = ancrage(p, panneau);
    if (point === null) return false;

    var vise = centre(p.li).c - point;

    var maxi = window.innerWidth - panneau.w - MARGE;
    if (vise > maxi) vise = maxi;
    if (vise < MARGE) vise = MARGE;

    // Deja en place : on ne touche a rien. C est aussi ce qui empeche
    // l observateur de se reveiller lui-meme sans fin.
    if (Math.abs(panneau.l - vise) < 0.5) return true;

    // On ne calcule pas la valeur de `left`, on la calibre : le panneau est
    // pose a zero, on regarde ou il tombe, et on en deduit le decalage exact.
    //
    // Le calcul theorique — soustraire la position du parent de reference —
    // etait faux des que le theme ajoutait autre chose. Il applique en effet
    // ses propres decalages : `translateX(-490px)` sur le panneau des housses,
    // `translateX(-240px)` sur ceux d Organisation et de Personnalisation. La
    // mesure, elle, englobe d office transformation, marges et boite de
    // reference, quelles qu elles soient.
    p.sub.style.setProperty('left', '0px', 'important');
    var zero = p.sub.getBoundingClientRect().left;
    p.sub.style.setProperty('left', Math.round(vise - zero) + 'px', 'important');
    return true;
  }

  function relacher(p) {
    if (p.sub.style.left) p.sub.style.removeProperty('left');
  }

  function surveiller(p) {
    if (p.sub.dataset[MARQUE]) return;
    p.sub.dataset[MARQUE] = '1';
    new MutationObserver(function () {
      if (window.innerWidth >= LARGEUR_MINI) caler(p);
    }).observe(p.sub, { attributes: true, attributeFilter: ['style'] });
  }

  // On ne verifie pas une fois mais pendant toute l ouverture.
  //
  // Le panneau met quelques trames a devenir mesurable, et surtout le theme
  // lui applique une transformation de glissement APRES coup, par une classe
  // CSS. Un calage pose trop tot restait donc juste une fraction de seconde,
  // puis le panneau sautait de 490 px vers la gauche. Comme caler() ne fait
  // rien quand la position est deja bonne, repasser a chaque trame ne coute
  // que des mesures, et rattrape ce que la transition deplace.
  var TRAMES = 40;   // environ deux tiers de seconde

  function insister(p, restant) {
    if (caler(p)) surveiller(p);
    if (restant > 0) requestAnimationFrame(function () { insister(p, restant - 1); });
  }

  document.addEventListener('mouseover', function (e) {
    if (window.innerWidth < LARGEUR_MINI) return;
    var cible = e.target;
    if (!cible || !cible.closest) return;
    var li = cible.closest('.t4s-navigation .t4s-type__mega');
    if (!li) return;
    var liste = panneaux();
    for (var i = 0; i < liste.length; i++) {
      if (liste[i].li === li) { insister(liste[i], TRAMES); return; }
    }
  }, true);

  var attente;
  window.addEventListener('resize', function () {
    clearTimeout(attente);
    attente = setTimeout(function () {
      var liste = panneaux();
      for (var i = 0; i < liste.length; i++) {
        if (window.innerWidth < LARGEUR_MINI) relacher(liste[i]);
        else caler(liste[i]);
      }
    }, 120);
  });
})();
